import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { RoomStateReportFormModel } from '../../models';

export const getDefaultValues = (
  globalSettings: GlobalSettingsModel
): RoomStateReportFormModel => ({
  date: globalSettings?.frontend_date,
  room_type_ids: [],
  occupancies_type: [],
  room_state: [],
  file_type: 'pdf',
});
